import React from "react"
import ReactDOM from "react-dom"
import "./index.scss"
import { Provider } from "react-redux"
import { persistor } from "./core/store/AppStore"
import { BrowserRouter } from "react-router-dom"
import { PersistGate } from "redux-persist/integration/react"
import "bootstrap/dist/css/bootstrap.min.css"
import { store } from "./core/store"
import { Amplify } from "aws-amplify"
import { sessionStorage } from 'aws-amplify/utils'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import CognitoOTPApp from "CognitoOTPApp"
import CognitoOTPAuthProvider from "cognito/CognitoOTPAuthProvider"


<script src="//cdn.jsdelivr.net/npm/sweetalert2@11"></script>

// eslint-disable-next-line no-undef
declare const document: Document

const CognitoOTPAuthWrapper = () => {
  const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID || "",
    ClientId: process.env.REACT_APP_CLIENT_ID || ""
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: poolData.UserPoolId,
        userPoolClientId: poolData.ClientId
      },
    }
  });

  cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

  return (<CognitoOTPAuthProvider><CognitoOTPApp /></CognitoOTPAuthProvider>)
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <CognitoOTPAuthWrapper />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)
